








































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import SvcCatatanPemberianObat from "@/services/CatatanPemberianObat";
import { appModule } from "@/store/modules/app";

interface DataCpo {
  cpo_item_id: number;
  resep_obat_id: string;
  resep_rute_id: string;
  resep_rute: string;
  resep_dosis: string;
  resep_frekuensi_id: string;
  dr_id: string;
  kd_obat: string;
  disp_qty: string;
  unit_id: string;
  keterangan: string;
  dosis: string;
  rute: string;
  jadwal: string;
  r: string;
}

@Component({
  components: {},
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CpoDosisModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() err!: object;
  @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() tipe: string;
  @Prop() disabled: boolean;
  @Prop({ required: true }) dataCpo!: DataCpo;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  validasi = [v => !!v || "*Kolom ini harus diisi"];
  modalTtd = false;
  alert = "";
  saving = false;

  mounted() {}

  get storeUser() {
    return userModule.user;
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  @Watch("value")
  changeValue(val) {}

  @Watch("tipe", { immediate: true, deep: true })
  onTipeChange(val) {
    if (val == "rute") {
      this.dataCpo.rute = this.dataCpo.rute
        ? this.dataCpo.rute
        : this.dataCpo.resep_rute;
    }
    if (val == "dosis") {
      this.dataCpo.dosis = this.dataCpo.dosis
        ? this.dataCpo.dosis
        : this.dataCpo.resep_dosis;
    }
  }

  get input() {
    return {
      cpo_item_id: this.dataCpo.cpo_item_id,
      register_id: this.register,
      pasien_rm: this.rm,
      resep_obat_id: this.dataCpo.resep_obat_id,
      resep_rute_id: this.dataCpo.resep_rute_id,
      resep_dosis: this.dataCpo.resep_dosis,
      resep_frekuensi_id: this.dataCpo.resep_frekuensi_id,
      dr_id: this.dataCpo.dr_id,
      kd_obat: this.dataCpo.kd_obat,
      disp_qty: this.dataCpo.disp_qty,
      unit_id: this.dataCpo.unit_id,
      keterangan: this.dataCpo.keterangan,
      dosis_text: this.dataCpo.dosis,
      rute_text: this.dataCpo.rute,
      jadwal_text: this.dataCpo.jadwal,
      r: this.dataCpo.r
    };
  }

  async save() {
    if (this.readOnly) return;
    if (this.tipe == "dosis" && !this.input.dosis_text) {
      alert("isi dosis dulu");
      return;
    }
    if (this.tipe == "rute" && !this.input.rute_text) {
      alert("isi rute dulu");
      return;
    }
    if (this.tipe == "jadwal" && !this.input.jadwal_text) {
      alert("isi jadwal dulu");
      return;
    }
    if (!this.saving) {
      this.saving = true;
      const save = this.input.cpo_item_id
        ? SvcCatatanPemberianObat.update(this.input.cpo_item_id, this.input)
        : SvcCatatanPemberianObat.create(this.input);

      save
        .then(resp => {
          if (resp.status == 1) {
            if (this.tipe == "dosis") {
              appModule.NoticeDelay("Berhasil menambahkan Dosis");
            } else {
              appModule.NoticeDelay("Berhasil menambahkan Jadwal");
            }
            // this.$emit("reload");
            this.$emit("replace", {
              kodeObat: this.dataCpo.kd_obat,
              patch: {
                cpo_item_id: resp.data.id,
                dosis: resp.data.dosis_text,
                jadwal: resp.data.jadwal_text,
                rute: resp.data.rute_text
              }
            });
            this.dialog = false;
          } else {
            appModule.sendErrorAlert(resp.message);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  close() {
    this.dialog = false;
  }
}
